export default __webpack_public_path__ + "97e4b424825cd006cb5d89bd7ec25b79.png";